import React, { useState } from 'react';
import { ContactForm } from '../components/ContactForm';

const ARTISTEK_URL = 'https://artistek.io';
const ARTISTEK_LOGO = '/artistek-io-w-logo.svg';

export function ContactPage() {
  const [showForm, setShowForm] = useState(false);

  return (
    <section className="panel muted inner-page">
      {!showForm ? (
        <div className="artistek-booking">
          <a
            className="artistek-logo-link"
            href={ARTISTEK_URL}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Artistek"
          >
            <img className="artistek-logo" src={ARTISTEK_LOGO} alt="Artistek" />
          </a>

          <div className="artistek-copy">
            <p className="eyebrow">Official booking</p>
            <h2>We&apos;re on Artistek.</h2>
            <p className="lede artistek-lede">The official community for regional live music. All in one place.</p>
            <ul className="artistek-points">
              <li>Real-time holds and routing used by serious buyers nationwide</li>
              <li>Clean contracts, advancing, and settlement — all in one place</li>
              <li>The same desk the industry already trusts to book the room</li>
            </ul>
            <a className="hero-btn artistek-cta" href={ARTISTEK_URL} target="_blank" rel="noopener noreferrer">
              Book Harlan on Artistek
            </a>
          </div>

          <p className="artistek-long-road">
            Still stuck booking bands on 90&apos;s technology? Email, SMS, DMs...{' '}
            <button className="text-cta as-button" type="button" onClick={() => setShowForm(true)}>
              click here to take the long road and submit a booking form
            </button>
            .
          </p>
        </div>
      ) : (
        <div className="contact-form-view">
          <button className="text-cta as-button contact-back" type="button" onClick={() => setShowForm(false)}>
            ← Back to Artistek booking
          </button>
          <div className="panel-header">
            <p className="eyebrow">The long road</p>
            <h2>Booking inquiry</h2>
            <p className="lede">Prefer a form? Send the details and we&apos;ll follow up. Artistek is still faster.</p>
          </div>
          <div className="card contact-card contact-form-card">
            <ContactForm />
          </div>
        </div>
      )}
    </section>
  );
}
